exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".meterWrapper--2QGFN {\n  max-width: 300px;\n  margin: auto;\n}\n\n.meterWrapper--2QGFN .meter--2hs5C {\n  background-color: #eff3f6;\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  padding-bottom: 100%;\n  border-radius: 50%;\n}\n\n.meterWrapper--2QGFN .meter--2hs5C img {\n  position: absolute;\n  width: 70%;\n  max-width: 70%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.meterWrapper--2QGFN .meter--2hs5C .filled--1rVi6 {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background-color: #db9905;\n}\n\n", ""]);

// exports
exports.locals = {
	"meterWrapper": "meterWrapper--2QGFN",
	"meter": "meter--2hs5C",
	"filled": "filled--1rVi6"
};